import { TMessageKey } from "@/i18n/types.gen";
import { TagColor } from "@/components-v2/Tag";

export enum AccessType {
  ADMIN = "ADMIN",
  SHAREHOLDER = "SHAREHOLDER",
  ADDITIONAL_REPRESENTATIVE = "ADDITIONAL_REPRESENTATIVE",
  BOARD_MEMBER = "BOARD_MEMBER",
  SUPERADMIN = "SUPERADMIN",
  NONE = "NONE",
  CUSTOM = "CUSTOM",
  DRAFT = "DRAFT",
}

export const accessLabels: { [key in AccessType]: TMessageKey } = {
  [AccessType.SHAREHOLDER]: "portfolio.SHAREHOLDER",
  [AccessType.ADDITIONAL_REPRESENTATIVE]: "portfolio.ADDITIONAL_REPRESENTATIVE",
  [AccessType.ADMIN]: "common.admin",
  [AccessType.BOARD_MEMBER]: "portfolio.BOARD_MEMBER",
  [AccessType.SUPERADMIN]: "portfolio.SUPERADMIN",
  [AccessType.NONE]: "portfolio.NONE",
  [AccessType.DRAFT]: "portfolio.DRAFT",
  [AccessType.CUSTOM]: "custom",
};

export const accessColors: { [key in AccessType]: TagColor } = {
  [AccessType.ADMIN]: "info",
  [AccessType.CUSTOM]: "info",
  [AccessType.SHAREHOLDER]: "success",
  [AccessType.ADDITIONAL_REPRESENTATIVE]: "success",
  [AccessType.BOARD_MEMBER]: "warning",
  [AccessType.SUPERADMIN]: "error",
  [AccessType.NONE]: "neutral",
  [AccessType.DRAFT]: "neutral",
};
